import {ButtonBase, Grid, Typography} from "@mui/material";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";
import {Link as RouterLink} from "react-router";

const Tecnicas_Martha = () => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            component="section"
            role="region"
            aria-label="Remodelación de espacios"
            itemScope
            itemType="https://schema.org/Service"
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12, sm: 12, md: 12 }}
            sx={{ background: "#223B59", }}
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                size={{ xs: 12, sm: 12, md: 10 }}
                sx={{ maxWidth: "1400px", px: 3, py: 16 }}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    size={{ xs: 12, sm: 12, md: 12 }}
                >
                    <Typography
                        component="p"
                        itemProp="description"
                        sx={{
                            fontSize: "24px",
                            fontWeight: 300,
                            color: "white",
                            textAlign: "center",
                            lineHeight: 1.2,
                        }}
                    >
                        Con técnicas prácticas, asesorías claras y propuestas visuales, te ayudamos a optimizar cada metro cuadrado para que vivas bonito, cómodo y en equilibrio con tu entorno
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Tecnicas_Martha;
